import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import { routes } from './config';
import Protected from './protected';
import Permitted from './permitted';

const Router = () => (
  <BrowserRouter>
    <Switch>
      
      {routes.map((route, i) => {
        if (route.redirect) return <Redirect exact to={route.redirect} key={i} />;
        if (route.protected) return <Protected exact {...route} key={i} />;
        return <Permitted exact {...route} key={i} />;
      })}

    </Switch>
  </BrowserRouter>
);

export default Router;
